export default [
    { icon: 'insert_drive_file', subtitle: 'Arquivo', mimeType: '', type: 'application'},
    { icon: 'image', subtitle: 'Imagem', mimeType: 'image', type: 'image' },
    { icon: 'music_note', subtitle: 'Áudio', mimeType: 'audio', type: 'audio' },
    { icon: 'movie', subtitle: 'Vídeo', mimeType: 'video', type:'video' },
  ];